import css from 'styled-jsx/css'

export default css.div`
  .text-card {
    position: relative;
  }
  
  .text-card .content-wrapper {
    max-height: 11.25rem;
    margin-top: 8px;
    margin-left: 2.5%;
  }  
  
  .text-card .date {
    margin-top: 8px;
  } 
  
  .text-card .title {
    font-size: 1.22rem;
  }
  
  .text-card .title-container {
    margin-top: 8px;
  }  
  
  .text-card .description {
    overflow: hidden;
    font-size: 0.833rem;
    margin-top: 0.444rem;
    line-height: 1.222rem;
    min-height: 2rem;
    max-height: 2.5rem;
  }
`
